import { 
  INSTAGRAM_INFO_UNSET, 
  INSTAGRAM_INFO_SET 
} from "state/types/UserTypes";
import { InitialState } from "state/InitialState";

export const InstagramInfoReducer = (state = {}, action) => {
  switch (action.type) {
    case INSTAGRAM_INFO_UNSET:
      return Object.assign({}, InitialState.createSyncObject());
    case INSTAGRAM_INFO_SET:
    default:
      return Object.assign({}, state, action.payload);
  }
};
